// import store from '../store'

// 關閉 Popup
export const mixins = {
  methods: {
  }
}
